import { useState } from 'react';
import { getImage } from '../../../server/server-media';

interface SlideshowProps {
    images: any[]; // Lista slika sa ID-jem
    width?: number | string; // Širina može biti u px ili %
    height?: number | string; // Visina može biti u px ili %
}

const Slideshow = ({ images, width = '100%', height = 250 }: SlideshowProps) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const nextSlide = () => {
        setCurrentIndex((prev) => (prev + 1) % images.length);
    };

    const prevSlide = () => {
        setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
    };

    const goToSlide = (index: number) => {
        setCurrentIndex(index);
    };

    return (
        <div style={{ display: 'flex', flex: 1, flexDirection: 'column', maxWidth: width, textAlign: 'center' }}>
            <div style={{ position: 'relative' }}>
                {images.map((item, index) => (
                    <div key={index} style={{ display: currentIndex === index ? 'block' : 'none' }}>
                        <img
                            src={getImage(item?.image?.id)}
                            alt=""
                            style={{
                                width: '100%',
                                height,
                                objectFit: 'contain',
                                objectPosition: 'center',
                            }}
                        />
                    </div>
                ))}

                {/* Dugmići za navigaciju */}
                {images.length > 1 && (
                    <>
                        <button className="prev" onClick={prevSlide}>
                            ❮
                        </button>
                        <button className="next" onClick={nextSlide}>
                            ❯
                        </button>
                    </>
                )}
            </div>

            {/* Tačkice za navigaciju */}
            {images.length > 1 && (
                <div style={{ marginTop: 10 }}>
                    {images.map((_, index) => (
                        <span
                            key={index}
                            className=""
                            onClick={() => goToSlide(index)}
                            style={{
                                cursor: 'pointer',
                                height: 12,
                                width: 12,
                                margin: '0 5px',
                                backgroundColor: currentIndex === index ? '#717171' : '#bbb',
                                borderRadius: '50%',
                                display: 'inline-block',
                                transition: 'background-color 0.6s ease',
                            }}
                        ></span>
                    ))}
                </div>
            )}
        </div>
    );
};

export default Slideshow;
